export default __webpack_public_path__ + "static/media/news-feed-latest.e748527c.svg";